import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-28 text-center">
      <XCircle className="w-16 h-16 mx-auto text-gray-500" />
      <h1 className="mt-6 font-heading text-3xl font-black">Paiement annulé</h1>
      <p className="mt-3 text-gray-400">Votre commande n'a pas été finalisée. Votre panier vous attend toujours.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/panier" className="btn-primary rounded-full px-7 py-3 font-bold">Retour au panier</Link>
        <Link to="/boutique" className="rounded-full border border-white/20 px-7 py-3 font-bold">Continuer mes achats</Link>
      </div>
    </div>
  );
}
